var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user)?_c('UsersForm',{attrs:{"user":_vm.user,"user-id":_vm.user.id,"label":"Edit User","on-success":_vm.onSuccess}}):_vm._e(),(_vm.error)?_c('div',[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }